import appraisalAcl from '../common-configuration/appraisal/acl'
import mainAcl from '../common-configuration/main/acl'

export default (route) => {
  return {
    ...mainAcl(route),
    ...appraisalAcl(route)
  }
}
